export enum CanvasCoordinatePointUnitEnum {
  PX,
  INCH,
}
